export const open_product_modal = 'open_product_modal';
export const openProductModal = (product) => ({
    type: open_product_modal,
    data: product,
});

export const close_product_modal = 'close_product_modal';
export const closeProductModal = () => ({
    type: close_product_modal,
});
